import { ActionDisabledCondition, UserAction } from '@mediahaven/shared';
import { ApiFragment } from '@stylehaven/components';

/*  Contact admin
 *  Available when:
 *   * Is published or archived
 *
 *  Disabled when:
 *   * No email is set
 *   * No baseUrl is set
 */
export function GetContactAdminUserAction(
    record: ApiFragment,
    email: string | undefined,
    baseUrl: string | undefined
): UserAction {
    const isPublished: boolean = record.isPublished();
    const isArchived: boolean = record.isArchived();
    const isDeleted: boolean = record.isDeleted();

    const availableConditions: boolean[] = [isPublished || isArchived, !isDeleted];
    const disableConditions: ActionDisabledCondition[] = [
        { condition: !email, tooltip: 'contact-admin.no-email', entitySpecificTooltip: false },
        { condition: !baseUrl, tooltip: 'contact-admin.no-base-url', entitySpecificTooltip: false }
    ];

    const contactAction: UserAction = new UserAction(availableConditions, disableConditions);

    return contactAction;
}
